import { render, staticRenderFns } from "./all-news-cmp.vue?vue&type=template&id=06943bab"
import script from "./all-news-cmp.vue?vue&type=script&lang=js"
export * from "./all-news-cmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports